import {Injectable} from '@angular/core';
import {HttpHeaders} from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';
import { Page } from './shared/models/page';
import {APP_CONSTANTS} from './utils/app-constants';

@Injectable({ providedIn: 'root' })

export class DTFService {
  

    public PATH_SEPERATOR = '/';

   private BASE_PATH = '/services/';
    // private BASE_PATH = 'https://dtfs-stg.daimler-truckfinancial.com/services/';
    // private BASE_PATH = 'http://localhost:8090/services/';
    private USERS_PATH = 'users/getUserDetails/';
    private PAYOFF_PATH = 'payoff/';
    private FAW_PATH = 'agent/';
    private AMORT_PATH = 'amort/';
    private INVOICE_PATH = 'invoice/';
    private INTEREST_PATH = 'interestletter/';    
    private LOGIN_PATH = 'login/';
    private CCPA_PATH = 'ccpa/';
    private CONTENT_PATH = 'content/';
    private DOCUMENT_PATH = 'documentCenter/';
    private DYNAMIC_LEASE_PATH = 'dynamiclease/';
    // private BANNERS_PATH = 'content/banners';
    private REGISTRATION_PATH = 'registration/';
    private MANAGEYOURPROFILE_PATH = 'manageYourProfile/';
    private CHANGEPASSWORD_PATH  = 'changepassword/';
    private EMAILPREFERENCE_PATH = 'editEmailAction/';
    private EBILL_PATH = 'ebill/';
    private USEANDPRIVACY_PATH = 'useAndPrivacy/';
    private UTIL_PATH = 'util/';
    // private PAGE_PATH = 'content/pages/';
    private AUTH_TOKEN_PATH = "security/authenticate"
    private ACCOUNT_PATH = 'account/';
    private RESET_PATH = 'resetPassword/';
    private PAYMENTOPTION_PATH = 'paymentOption/';
    private AUTOPAY_PATH = 'autopay/';
    private FORM_PATH = 'form/';
    private ADMIN_PATH = 'admin/';
    private VERTEX_PATH = 'vertex/';
    private PAYMENT_HISTORY_PATH = 'paymenthistory/';
    private OLP_PATH = 'paynow/';
    private GUEST_PAY = 'guestpay/';

     // private REGISTRATION_PATH = 'prepareToRegisterUser/';
    private HTTP_HEADERS = new HttpHeaders().set('Content-Type', 'application/json').set('Systemid', 'A4444');
    conversionEncryptOutput: string;

    // getBannersUrl() {
    //     return this.BASE_PATH + this.BANNERS_PATH;
    // }
    getCaptcha() {
      return this.BASE_PATH + this.CONTENT_PATH + 'checkcaptcha';
    }
    getAlerts() {
      return this.BASE_PATH + this.CONTENT_PATH + 'getAlerts';
    }
    getAlertsAdmin() {
      return this.BASE_PATH + this.CONTENT_PATH + 'getAlertsAdmin';
    }
    getCustomerDetails(){
      return this.BASE_PATH + this.GUEST_PAY + 'getCustomerDetails';
    }
    getUserDetailsFromCodeUrl() {
      return this.BASE_PATH + this.REGISTRATION_PATH + 'getUserDetailsFromCode';
    }
    registerProfile() {
    return this.BASE_PATH + this.REGISTRATION_PATH + 'registerUser';
    }
    startSession() {
      return this.BASE_PATH + this.REGISTRATION_PATH + 'insertSession';
    }
    insertUser() {
    return this.BASE_PATH + this.REGISTRATION_PATH + 'getUserByUserId';
    }

     // OLP

    PayToggle(){
      return this.BASE_PATH + this.OLP_PATH + 'PayToggle'; 
    }

    getODSThirdPartyAccountSummary(){
      return this.BASE_PATH + this.OLP_PATH + 'getAccountSummary'; 
    }

    getBankName(){
      return this.BASE_PATH + this.OLP_PATH + 'getBankName';
    }
    validateBank(){
      return this.BASE_PATH + this.OLP_PATH + 'validateBank';
    }

    bankProfile(){
      return this.BASE_PATH + this.OLP_PATH + 'bankProfile';
    }

    saveProfile(){
      return this.BASE_PATH + this.OLP_PATH + 'saveProfile';
    }

    updateProfile(){
      return this.BASE_PATH + this.OLP_PATH + 'updateProfile';
    }

    deleteProfile(){
      return this.BASE_PATH + this.OLP_PATH + 'deleteProfile';
    }

    getInvoiceList(){
      return this.BASE_PATH + this.OLP_PATH + 'getInvoiceList'; 
    }

    orders(){
      return this.BASE_PATH + this.OLP_PATH + 'orders'; 
    }

    subscriptions(){
      return this.BASE_PATH + this.OLP_PATH + 'subscriptions'; 
    }

    subscriptionsList(){
      return this.BASE_PATH + this.OLP_PATH + 'subscriptionsList'; 
    }

    cancelSubscription(){
      return this.BASE_PATH + this.OLP_PATH + 'cancelSubscription'; 
    }

    guestPayPayment(){
      return this.BASE_PATH + this.GUEST_PAY + 'guestPayPayment'; 
    }

    verifyUserId() {
      return this.BASE_PATH + this.REGISTRATION_PATH + 'verifyUserId';
      }
    prepareToRegisterUser() {
        return this.BASE_PATH + this.REGISTRATION_PATH + 'prepareToRegisterUser';
     }
    prepareAccountSetup(){
        return this.BASE_PATH + this.REGISTRATION_PATH + 'prepareAccountSetup';
    }
    deleteUser(){
        return this.BASE_PATH + this.REGISTRATION_PATH + 'deleteUser';
    }
    updateAndSendEmailToUser(){
      return this.BASE_PATH + this.REGISTRATION_PATH + 'updateAndSendEmailToUser ';
    }
    getlistAllPaymentsForSchedule(){
      return this.BASE_PATH + this.PAYMENT_HISTORY_PATH + 'listallpayments';
    }
    getManageYourProfile(){
      return this.BASE_PATH + this.MANAGEYOURPROFILE_PATH + 'getManageYourProfile'; 
    }
    updateAndSaveNewPassword(){
      return this.BASE_PATH + this.CHANGEPASSWORD_PATH + 'updateAndSaveNewPassword'; 
    }

    updateAndSaveNewAdminPassword(){
      return this.BASE_PATH + this.CHANGEPASSWORD_PATH + 'updateAndSaveNewAdminPassword'; 
    }
    updateEmailPreferences(){
      return this.BASE_PATH + this.EMAILPREFERENCE_PATH + 'updateEmailPreferences'; 
    }
    fetchEbillFlagForUser(){
      return this.BASE_PATH + this.EBILL_PATH + 'fetchEbillFlagForUser'; 
    }
    saveEnrollOrCancelOptionToALFA(){
      return this.BASE_PATH + this.EBILL_PATH + 'saveEnrollOrCancelOptionToALFA'; 
    }
    getUseAndPrivacy(){
      return this.BASE_PATH + this.USEANDPRIVACY_PATH + 'getUseAndPrivacy'; 
    }
    getPaymentOption(){
      return this.BASE_PATH + this.PAYMENTOPTION_PATH + 'getPaymentOption'; 
    }
    // getPage(pageId: string) {
    //   return this.BASE_PATH + this.PAGE_PATH + pageId;
    // }
    // updatePageDetails(page: Page) {
    //   return this.BASE_PATH + this.BANNERS_PATH + 'pages/updatepage';
    // }

    getHttpHeaders() {
      return this.HTTP_HEADERS;
    }

    getCustomerDetailsUrl() {
      return this.BASE_PATH + this.USERS_PATH + 'customerDetails';
    }

    getAuthUrl() {
      return this.BASE_PATH + this.AUTH_TOKEN_PATH;
    }

    getTerminationQuote() {
      return this.BASE_PATH + this.PAYOFF_PATH + 'getTerminationQuote';
    }

    getTerminationQuoteByVin() {
      return this.BASE_PATH + this.PAYOFF_PATH + 'getTerminationQuoteByVin';
    }

    getAgreementDetails(userId: string) {
      return this.BASE_PATH + this.PAYOFF_PATH + 'getAgreementDetails' + userId;
    }
    getAgreementAssetDetail() {
      return this.BASE_PATH + this.PAYOFF_PATH + 'getAgreementAssetDetail';
    }

    getMultiAgreementAssetDetail() {
      return this.BASE_PATH + this.PAYOFF_PATH + 'getMultiAgreementAssetDetail';
    }
    getVinDetails() {
      return this.BASE_PATH + this.PAYOFF_PATH + 'getVinDetails';
    }
    getMultiPayoff() {
      return this.BASE_PATH + this.PAYOFF_PATH + 'getMultiPayoff';
    }
    viewPayoff() {
      return this.BASE_PATH + this.PAYOFF_PATH + 'viewPayoff';
    }
    listliveAndExpiredQuotes() {
      return this.BASE_PATH + this.PAYOFF_PATH + 'listliveAndExpiredQuotes';
    }
    getAmort() {
      return this.BASE_PATH + this.AMORT_PATH + 'getAmortSchedule';
    }

    submitCCPA() {
      return this.BASE_PATH + this.CCPA_PATH + 'submit';
    }

    //   getInvoice() {
    //    return this.BASE_PATH + this.INVOICE_PATH + 'getInvoiceDetailsByCcanId';
    //  }

     getInvoice() {
       return this.BASE_PATH + this.INVOICE_PATH + 'fetchEncodedInvoiceList';
     }
    //  fetchEncodedInvoice() {
    //   return this.BASE_PATH + this.INVOICE_PATH + 'fetchEncodedInvoice';
    // }
    fetchEncodedInvoiceList() {
      return this.BASE_PATH + this.INVOICE_PATH + 'fetchEncodedInvoiceList';
    }
    // getInvoiceDetailsUnEncoded() {
    //   return this.BASE_PATH + this.INVOICE_PATH + 'getInvoiceDetailsUnEncoded';
    // }
    fetchInvoiceDetailsfromDB() {
      return this.BASE_PATH + this.INVOICE_PATH + 'fetchInvoiceDetailsfromDB';
    }

     retrieveInterestLetter() {
      return this.BASE_PATH + this.INTEREST_PATH + 'retrieveInterestLetter';
    }
    adminretrieveInterestLetter() {
      return this.BASE_PATH + this.INTEREST_PATH + 'adminretrieveInterestLetter';
    }
    getUser(){
      return this.BASE_PATH + this.LOGIN_PATH + 'getPasswordResetFlag';
    }
    getLogin(){
      return this.BASE_PATH + this.LOGIN_PATH + 'prepareLoginAndSaveSessionData';
    }
    login(){
      return this.BASE_PATH + this.LOGIN_PATH + 'login';
    }
    getPreLogin(){
      return this.BASE_PATH + this.LOGIN_PATH + 'getPreLogin';
    }
    emailVerificationForLogin(){
      return this.BASE_PATH + this.LOGIN_PATH + 'emailVerificationForLogin';
    }
    clearSessionData(){
      return this.BASE_PATH + this.LOGIN_PATH + 'clearSessionData';
    }
    getDashBoardDetails(){
      return this.BASE_PATH + this.LOGIN_PATH + 'getDashBoardDetails';
    }
    getAccountDetailsListByUserId(){
      return this.BASE_PATH + this.LOGIN_PATH + 'getAccountDetailsListByUserId';
    }
    getTerminatedAccounts(){
      return this.BASE_PATH + this.LOGIN_PATH + 'getTerminatedAccounts';
    }
    getMaturedAccounts(){
      return this.BASE_PATH + this.LOGIN_PATH + 'getMaturedAccounts';
    }
    decryptFawToken(){
      return this.BASE_PATH + this.FAW_PATH + 'decryptFawToken';
    }

    getDocumentList(){
      return this.BASE_PATH + this.DOCUMENT_PATH + 'ECMDocRequestComplete';
    }

    getCounties(){
      return this.BASE_PATH + this.DYNAMIC_LEASE_PATH + 'getCounties';
    }

    getStates(){
      return this.BASE_PATH + this.DYNAMIC_LEASE_PATH + 'getStates';
    }

    
    dynamicAddendum(){
      return this.BASE_PATH + this.DYNAMIC_LEASE_PATH + 'dynamicAddendum';
    }

    fetchDynamicAddendumAssetHistory(){
      return this.BASE_PATH + this.DYNAMIC_LEASE_PATH + 'fetchDynamicAddendumAssetHistory';
    }
    getPasswordResetStepOne(){
      return this.BASE_PATH + this.RESET_PATH + 'prepareForPasswordResetStepOne';
    }

    validateTokenFromEmail(){
      return this.BASE_PATH + this.RESET_PATH + 'validateTokenFromEmail';
    }
    emailverification(){
      return this.BASE_PATH + this.REGISTRATION_PATH + 'emailVerification';
    }

    prepareToSaveNewPassword(){
      return this.BASE_PATH + this.RESET_PATH + 'prepareToSaveNewPassword';
    }
    encryptCTR(){
      return this.BASE_PATH + this.UTIL_PATH + 'encryptCTR';
    }
    decryptCTR(){
      return this.BASE_PATH + this.UTIL_PATH + 'decryptCTR';
    }
    getCalculator(){
      return this.BASE_PATH + this.UTIL_PATH + 'calculator';
    }
    isPcAutopayEnabled(){
      return this.BASE_PATH + this.AUTOPAY_PATH + 'isPcAutopayEnabled';
    }
    getValidAutopayAccounts(){
      return this.BASE_PATH + this.AUTOPAY_PATH + 'getValidAutopayAccounts';
    }
    // verifyAccountNumber(){
    //   return this.BASE_PATH + this.AUTOPAY_PATH + 'verifyAccountNumber';
    // }
    // getRoutingNumber(){
    //   return this.BASE_PATH + this.AUTOPAY_PATH + 'getRoutingNumber';
    // }
    getBankProfileDetailsforAutopayAccounts(){
      return this.BASE_PATH + this.AUTOPAY_PATH + 'getBankProfileDetailsforAutopayAccounts';
    }
    setAutoPayAndBankProfile(){
      return this.BASE_PATH + this.AUTOPAY_PATH + 'setAutoPayAndBankProfile';
    }
    editAutoPayAndBankProfile(){
      return this.BASE_PATH + this.AUTOPAY_PATH + 'editAutoPayAndBankProfile';
    }
    deleteAutoPayAndBankProfile(){
      return this.BASE_PATH + this.AUTOPAY_PATH + 'deleteAutoPayAndBankProfile';
    }
    contractAndtitleStateTransfer(){
      return this.BASE_PATH + this.FORM_PATH + 'contractAndtitleStateTransfer';
    }
    changeOfAddress(){
      return this.BASE_PATH + this.FORM_PATH + 'submitAddressChange';
    }
    setTitleAuthorization(){
      return this.BASE_PATH + this.FORM_PATH + 'setTitleAuthorization';
    }

    fetchAdminInvoiceDetailsfromDB(){
      return this.BASE_PATH + this.ADMIN_PATH + 'fetchInvoiceDetailsfromDB';
    }

    saveLineItemFlag(){
      return this.BASE_PATH + this.ADMIN_PATH + 'saveLineItemFlag';
    }

    saveAdminAuditLog(){
      return this.BASE_PATH + this.ADMIN_PATH + 'saveAdminAuditLog';
    }

    savePaymentFlag(){
      return this.BASE_PATH + this.ADMIN_PATH + 'savePaymentFlag';
    }

    saveBannerData(){
      return this.BASE_PATH + this.ADMIN_PATH + 'saveBannerData';
    }
    fetchAdminEncodedInvoiceList() {
      return this.BASE_PATH + this.ADMIN_PATH + 'fetchEncodedInvoiceList';
    }

    fetchAdminList() {
      return this.BASE_PATH + this.ADMIN_PATH + 'fetchAdminList';
    }

    fetchUserList() {
      return this.BASE_PATH + this.ADMIN_PATH + 'fetchUserList';
    }
    unlockUser(): string {
      return this.BASE_PATH + this.ADMIN_PATH + 'unlockMfa';
    }
    updateEmail(): string {
      return this.BASE_PATH + this.ADMIN_PATH + 'updateUserEmail';
    }
    inactivateUser(): string {
      return this.BASE_PATH + this.ADMIN_PATH + 'inactivateUser';
    }
    reactivateUser(): string {
      return this.BASE_PATH + this.ADMIN_PATH + 'reactivateUser';
    }
    saveAdminDetails() {
      return this.BASE_PATH + this.ADMIN_PATH + 'saveAdminDetails';
    }
    getAdminUser(){
      return this.BASE_PATH + this.ADMIN_PATH + 'getPasswordResetFlag';
    }
    adminLogin(){
      return this.BASE_PATH + this.ADMIN_PATH + 'adminLogin';
    }
    prepareForAdminResetStepOne() {
      return this.BASE_PATH + this.ADMIN_PATH + 'prepareForAdminResetStepOne';
    }

    validateAdminTokenFromEmail() {
      return this.BASE_PATH + this.ADMIN_PATH + 'validateTokenFromEmail';
    }

    prepareToSaveAdminNewPassword(){
      return this.BASE_PATH + this.ADMIN_PATH + 'prepareToSaveNewPassword';
    }

    validateAddress(){
      return this.BASE_PATH + this.VERTEX_PATH + 'validateAddress';
    }

    forgotUserId(){
      return this.BASE_PATH + this.LOGIN_PATH + 'forgotUserId';
    }
  
    convertText(text:string) {
      let map = new Map([[ "a", 1 ],[ "b", 2 ],[ "c", 3 ],[ "d", 4 ],[ "e", 5 ],[ "f", 6 ],
      [ "g", 7 ],[ "h", 8 ],[ "i", 9 ],[ "j", 10 ],[ "k", 11 ],[ "l", 12 ],[ "m", 13 ],[ "n", 14 ],
      [ "o", 15 ],[ "p", 16 ],[ "q", 17 ],[ "r", 18 ],[ "s", 19 ],[ "t", 20 ],[ "u", 21 ],[ "v", 22 ],
      [ "w", 23 ],[ "x", 24 ],[ "y", 25 ],[ "z", 26 ],["0",27],["1",28],["2",29],["3",30],["4",31],
      ["5",32],["6",33],["7",34],["8",35],["9",36]]);
      let passcode = "etgf@yugdrwRYbge$%y@*f)&eqyLNbae$&j@itGr67(%#fr5$jaq@(9pknhs&85#JteWqsdIye*5#&iametq&%!yHe$nh@th*0nb";
      let key = passcode.split('');
      let textArray = text.split('');
      let finalString = "";
      for (var i = 0; i < textArray.length; i++) {
        let textNum = map.get(textArray[i]);
        if(textNum){
          finalString = finalString+key[textNum]+key[textArray.length-i];
        }else{
          finalString = finalString+"%";
        }
      }
      finalString = finalString+key[textArray.length];
      this.conversionEncryptOutput = btoa(finalString);
    }

}
